import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdProductsSettingsCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/products_data",
  "/app_settings/segmentable_property_usage",
];
